<template>
  <section class="interview-section">
    <h2 class="section-title">
      Courses
    </h2>
    <p class="section-desc">
      {{ configs.courses && configs.courses.config_value }}
    </p>
    <div class="breadcrumb-container" v-once>
      <Breadcrumb
        :items="breadcrumbLinks"
        icon="chevron-right"
        showActions
        showNote
        note="KidsAssignmentNote"
        color="#5FD068"
        @finishBreadcrumb="reserveWebinar"
      />
    </div>
    <div class="date-selection">
      <h3 class="date-title">
        {{ $t("kidsReservations.selectDate") }}
      </h3>
      <div class="date-input-container">
        <v-menu
          v-model="dateDialog"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="selectedDateFormatted"
              label="Select Date"
              readonly
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-calendar-month-outline"
              class="date-input"
              solo
            ></v-text-field>
          </template>
          <v-date-picker
            v-bind:min="new Date().toISOString()"
            v-model="selectedDate"
            @input="changeWebinarsList"
          ></v-date-picker>
        </v-menu>
      </div>
    </div>

    <div class="session-selection">
      <template v-if="webinars.length">
        <h3 class="session-title">
          {{ $t("kidsReservations.availableSessions") }}
        </h3>
        <WebinarList :webinars="webinars" />
      </template>
      <template v-else>
        <h3 class="session-title text-center">
          {{ $t("kidsReservations.noAvailableSessions") }}
        </h3>
      </template>
    </div>

    <Modal
      :isOpened="finishDialog"
      :hideDefaultFooter="true"
      :hideDefaultHeader="true"
      :maxWidth="500"
      borderRadius="8"
    >
      <template #body>
        <div class="finish-body d-flex flex-column align-items-center">
          <p class="emoji">👍</p>
          <p class="done">All done!</p>
          <p class="desc text-center">
            Thanks for you reservation you will receive a confirmation email
            soon with all details.
          </p>
          <button @click="finishDialog = false">Close</button>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import moment from "moment";
import GlobalMixin from "../../GlobalMixin";
import KidsReservationMixin from "../../mixins/KidsReservationMixin";
import Modal from "../../components/global/Modal.vue";
import Breadcrumb from "../../components/global/Breadcrumb.vue";
import WebinarList from "../../components/KidsReservation/WebinarList.vue";

export default {
  name: "ScheduleInterviewView",
  mixins: [GlobalMixin, KidsReservationMixin],
  components: {
    Breadcrumb,
    WebinarList,
    Modal,
  },
  data() {
    return {
      dateDialog: false,
      finishDialog: false,
      selectedDate: moment(new Date()).format("yyyy-MM-DD"),
      webinars: [],
      lang: localStorage.lang,
      configs: JSON.parse(localStorage.getItem("configs")),
      user: this.$store?.getters?.StateUser?.user,
    };
  },
  async mounted() {
    this.webinars = await this.getAllSchedulingDetials(this.selectedDate);
    window.addEventListener("localstorageChange", (event) => {
      this.configs = JSON.parse(event.detail.storage.configs);
    });
  },
  destroyed() {
    window.removeEventListener("localstorageChange", () => {});
  },
  methods: {
    /**
     * Change interview list on date change
     */
    async changeWebinarsList() {
      this.$store.dispatch("removeWebinar");
      this.dateDialog = false;
      this.webinars = await this.getAllSchedulingDetials(this.selectedDate);
    },
    /**
     * Reserve a webinar for user and their kids
     * @returns void
     */
    reserveWebinar() {
      const users = this.$store.getters.GET_SELECTED_MATRIX.map((m) => m.user);
      if (!users.includes(this.user.id)) users.push(this.user.id);

      const body = {
        institute: +this.user.username.at(-1),
        webinar: this.$store.getters.GET_WEBINAR_ID,
        users,
      };

      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}p2p/webinars/subscribed-multiple-users/`,
          body,
          this.headers
        )
        .then((res) => {
          console.log("yes", res);
          this.finishDialog = true;
        })
        .catch((err) => this.formatErrors(err));
    },
  },
  computed: {
    selectedDateFormatted() {
      return moment(this.selectedDate)
        .locale(this.lang)
        .format("D MMMM YYYY");
    },
  },
  watch: {
    /**
     * Watch for language change
     */
    "$i18n.locale"(newVal) {
      this.lang = newVal;
    },
    /**
     * Watch for finish Dialog and if it's close naviagte user and delete all old selections
     */
    finishDialog(newVal) {
      if (!newVal) {
        this.$router.push({ name: "Webinars" });
      }
    },
  },
};
</script>

<style lang="scss">
:root {
  font-size: 16px;
}

@media all and (max-width: $min-md-screen) {
  :root {
    font-size: 14px;
  }
}
</style>

<style lang="scss" scoped>
.interview-section {
  max-width: $max-lg-screen;
  font-family: $font-family;
  font-style: normal;
  margin: auto;
  .section-title {
    font-weight: 600;
    font-size: 1.75rem;
    line-height: 2.125rem;
    color: $title;
    margin-bottom: 11px;
  }

  .section-desc {
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    color: $paragraph;
  }
  .breadcrumb-container {
    padding: 16px;
    background: $white;
    border: 1px solid $paragraph;
    border-radius: 8px;
    font-family: $font-family;
    font-style: normal;
    margin-bottom: 25px;
  }

  .date-selection {
    margin-top: 24px;
    font-family: $font-family;
    font-style: normal;
    .date-title {
      font-weight: 600;
      font-size: 1.25rem;
      line-height: 1.5rem;
      color: $title;
      margin-bottom: 24px;
    }

    .date-input-container {
      margin-bottom: 36px;
      .date-input {
        max-width: 557px;
      }
    }
  }

  .session-selection {
    margin-top: 24px;
    font-family: $font-family;
    font-style: normal;
    .session-title {
      font-weight: 600;
      font-size: 1.25rem;
      line-height: 1.5rem;
      color: $title;
      margin-bottom: 24px;
    }
  }
}
.finish-body {
  padding: 20px;
  font-family: $font-family;
  font-style: normal;
  .emoji {
    font-size: 3rem;
    margin-bottom: 5px;
  }
  .done {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    color: $black;
  }

  .desc {
    font-size: 1rem;
    color: #6a778b;
    max-width: 350px;
    margin-bottom: 25px;
  }

  button {
    background: $green;
    color: $white;
    padding: 10px;
    font-size: 1rem;
    border-radius: 8px;
    width: 100%;
    &:hover {
      background: $hover-green;
    }
  }
}

::v-deep .date-input {
  .v-input__slot {
    box-shadow: none !important;
    border: 1px solid #6a778b;
    border-radius: 8px;
    background: $white;
    padding: 10px 24px !important;
    .v-text-field__slot {
      color: #061c3d !important;
    }
    .v-icon {
      color: $black;
    }
  }
  .v-text-field__details {
    display: none !important;
  }
}

@media all and (max-width: $max-lg-screen) and (min-width: $min-lg-screen) {
  .interview-section {
    max-width: $min-lg-screen;
  }
}

@media all and (max-width: $min-lg-screen) and (min-width: $min-md-screen) {
  .interview-section {
    max-width: $min-md-screen;
  }
}

@media all and (max-width: $min-md-screen) and (min-width: $max-sm-screen) {
  .interview-section {
    max-width: $max-sm-screen;
  }
}

@media all and (max-width: $max-sm-screen) and (min-width: $min-sm-screen) {
  .interview-section {
    max-width: $min-sm-screen;
  }
}
</style>
